module.exports = __webpack_public_path__ + "img/home_phone_carousel2.cbb5674a.png";